module.exports = __webpack_public_path__ + "img/fi-rr-checkbox.d3844184.svg";